import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(
  '^https://([w.-]+.)?(mindmeister.com|mm.tt)(/maps/public_map_shell)?/(\\d+)(\\?t=.*)?(/.*)?$',
);
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const chartId = React.useMemo(() => {
    const matches = URL_REGEX.exec(url);
    return matches ? matches[4] + (matches[5] || '') + (matches[6] || '') : '';
  }, [url]);

  return (
    <Portal
      {...rest}
      url={`https://www.mindmeister.com/maps/public_map_shell/${chartId}`}
      title="Mindmeister Embed"
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'mindmeister-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Mindmeister',
    description: 'Embed a Mindmeister map.',
    searchTerms: ['embed', 'mindmeister'],
    icon: 'clarity:atom-line',
  },
});
